import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/material";
import { getsnackbarData, showSnackbar } from "Redux/ShowSnackbar";
import { useDispatch, useSelector } from "react-redux";


const DoriSnackbar = () => {
  const {
    message,
    severity,
    autoHideDuration,
    openSnackbar
  } = useSelector(getsnackbarData);
  const dispatch = useDispatch();

  // const [open, setOpen] = React.useState(openSnackbar);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    // setOpen(false);
    dispatch(showSnackbar({ openSnackbar: false }));
  };

  // console.log('opensnack bar', openSnackbar);

  return (
    <Snackbar
      style={{ position: 'absolute' }}
      open={openSnackbar}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={handleClose}
      message="Snackbar"
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{
          width: "100%",
          border: severity === 'error'
            ? '1px solid red'
            : severity === 'warning'
              ? '1px solid orange'
              : severity === 'success'
                ? '1px solid #17b696'
                : 'gray'
        }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default DoriSnackbar;
